import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangePassword } from '../models/change-password';
import { Observable } from 'rxjs';
import { UserTmp } from '../models/user-tmp';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

    private apiBaseUrl = `${environment.apiUrl}user`;

    constructor(private httpClient: HttpClient) { }

    public forgotPassword(email: string): Observable<Location> {
        let params = new HttpParams().set('email', encodeURIComponent(email));
        return this.httpClient.post<Location>(`${this.apiBaseUrl}/forgotPassword`, params);
    }

    public changePassword(changePassword: ChangePassword): Observable<void> {
        return this.httpClient.post<void>(`${this.apiBaseUrl}/changePassword`, changePassword);
    }

    public createUser(userTmp: UserTmp): Observable<void> {
        return this.httpClient.post<void>(`${this.apiBaseUrl}/createUser`, userTmp);
    }

    public confirmUserCreation(securityToken: string): Observable<void> {
        let params = new HttpParams();
        params = params.set('securityToken', securityToken);
        return this.httpClient.post<void>(`${this.apiBaseUrl}/confirmUserCreation`, params);
    }

    public patchLanguage(value: string) {
        let params = new HttpParams();
        params = params.set('lang', value);
        return this.httpClient.patch(`${this.apiBaseUrl}/patchLanguage`, params);
    }

    public requestChangePassword(): Observable<any> {
        return this.httpClient.get<any>(`${this.apiBaseUrl}/requestChangePassword`);
    }

    public validateToken(token: string): Observable<{ multiple: number }> {
        return this.httpClient.post<{ multiple: number }>(`${this.apiBaseUrl}/validateToken`, { token });
    }


}
